import * as z from "zod";

export const JobTaskSchema = z.object({
  id: z.string().uuid(),
  job_id: z.string().uuid(),
  title: z
    .string()
    .min(1, "Title is required")
    .max(255, "Title must be less than 255 characters"),
  description: z
    .string()
    .max(1000, "Description must be less than 1000 characters")
    .optional(),
  instructions: z
    .string()
    .max(2000, "Instructions must be less than 2000 characters")
    .optional(),
  estimated_duration: z
    .number()
    .int("Duration must be a whole number")
    .min(1, "Duration must be at least 1 minute")
    .optional(),
  equipment_id: z.string().uuid().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createJobTaskSchema = JobTaskSchema.omit({
  id: true,
  created: true,
  updated: true,
}).extend({
  equipment: z
    .object({
      id: z.string().uuid(),
      name: z.string(),
    })
    .optional(),
});

export const updateJobTaskSchema = JobTaskSchema.partial()
  .omit({
    id: true,
    job_id: true,
    created: true,
    updated: true,
  })
  .extend({
    equipment: z
      .object({
        id: z.string().uuid(),
        name: z.string(),
      })
      .optional(),
  });